import { DDDSymbolNames } from "../../../types/DDDEnums";
import { SymbolResizeConfig } from "../../../types/DDDInterfaces";

const config_M1: SymbolResizeConfig = {
    default: {
        scale: 0.5,
        offsetX: 0,
        offsetY: 0,
    }, //done
    x025: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 22,
    },
    x033: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 34,
    }, //done
    x075: {
        scale: 0.5,
        offsetX: 0,
        offsetY: 16,
    }, //done
};

const config_M2: SymbolResizeConfig = {
    default: config_M1.default,
    x025: {
        scale: 0.45,
        offsetX: 0,
        offsetY: -25,
    }, //done
    x033: {
        scale: 0.45,
        offsetX: 0,
        offsetY: -28,
    }, //done
    x075: {
        scale: 0.5,
        offsetX: 0,
        offsetY: -12,
    }, //done
};

const config_M3: SymbolResizeConfig = {
    default: config_M1.default,
    x025: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 9,
    }, //done,
    x033: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 18,
    }, //done
    x075: {
        scale: 0.45,
        offsetX: -4,
        offsetY: -4,
    }, //done
};

const config_M4: SymbolResizeConfig = {
    default: config_M1.default,
    x025: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 9,
    }, //done,
    x033: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 18,
    }, //done
    x075: {
        scale: 0.45,
        offsetX: -4,
        offsetY: -4,
    }, //done
};

const config_M5: SymbolResizeConfig = {
    default: config_M1.default,
    x025: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 15,
    }, //done,
    x033: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 20,
    }, //done
    x075: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 0,
    }, //done
};

const config_L1: SymbolResizeConfig = {
    default: config_M1.default,
    x025: {
        scale: 0.45,
        offsetX: 0,
        offsetY: -20,
    }, //done
    x033: {
        scale: 0.45,
        offsetX: 8,
        offsetY: -20,
    }, //done
    x075: {
        scale: 0.5,
        offsetX: 8,
        offsetY: -13,
    }, //done
};

const config_L2: SymbolResizeConfig = {
    default: config_M1.default,
    x025: {
        scale: 0.44,
        offsetX: 0,
        offsetY: -2,
    }, //done
    x033: {
        scale: 0.44,
        offsetX: 4,
        offsetY: -10,
    }, //done
    x075: {
        scale: 0.5,
        offsetX: 5,
        offsetY: 4,
    }, //done
};

const config_L3: SymbolResizeConfig = {
    default: config_M1.default,
    x025: {
        scale: 0.5,
        offsetX: 0,
        offsetY: 12,
    }, //done
    x033: {
        scale: 0.5,
        offsetX: 6,
        offsetY: 20,
    }, //done
    x075: {
        scale: 0.5,
        offsetX: 0,
        offsetY: 2,
    }, //done
};

const config_L4: SymbolResizeConfig = {
    default: config_M1.default,
    x025: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 0,
    }, //done
    x033: {
        scale: 0.43,
        offsetX: 5,
        offsetY: 0,
    }, //done
    x075: {
        scale: 0.5,
        offsetX: 2,
        offsetY: 5,
    }, //done
};

const config_L5: SymbolResizeConfig = {
    default: config_M1.default,
    x025: {
        scale: 0.44,
        offsetX: 8,
        offsetY: 0,
    },
    x033: {
        scale: 0.44,
        offsetX: 12,
        offsetY: -2,
    },
    x075: {
        scale: 0.5,
        offsetX: 3,
        offsetY: -8,
    }, //done
};

const config_SCATTER: SymbolResizeConfig = {
    default: {
        scale: 0.5,
        offsetX: 0,
        offsetY: -1,
    }, //done
    x025: {
        scale: 0.45,
        offsetX: 0,
        offsetY: 10,
    }, //done
    x033: {
        scale: 0.38,
        offsetX: 0,
        offsetY: -5,
    }, //done
    x075: {
        scale: 0.46,
        offsetX: -1,
        offsetY: -7,
    }, //done
};

const config_WILD: SymbolResizeConfig = {
    default: config_M1.default,
    x025: {
        scale: 0.44,
        offsetX: 0,
        offsetY: -22,
    },
    x033: {
        scale: 0.44,
        offsetX: 0,
        offsetY: -15,
    },
    x075: {
        scale: 0.5,
        offsetX: 0,
        offsetY: -3,
    }, //done
};

export const symbolsResizeConfig: Map<DDDSymbolNames, SymbolResizeConfig> = new Map([
    [DDDSymbolNames.M1, config_M1],
    [DDDSymbolNames.M2, config_M2],
    [DDDSymbolNames.M3, config_M3],
    [DDDSymbolNames.M4, config_M4],
    [DDDSymbolNames.M5, config_M5],
    [DDDSymbolNames.L1, config_L1],
    [DDDSymbolNames.L2, config_L2],
    [DDDSymbolNames.L3, config_L3],
    [DDDSymbolNames.L4, config_L4],
    [DDDSymbolNames.L5, config_L5],
    [DDDSymbolNames.SCATTER, config_SCATTER],
    [DDDSymbolNames.WILD, config_WILD],
]);
